import React from 'react';
import './legal.css';

type LegalLayoutProps = {
  eyebrow: string;
  title: string;
  intro: string;
  art: React.ReactNode;
  children: React.ReactNode;
};

/**
 * Inner shell for Datenschutz / Impressum / Cookie pages: gradient hero with an
 * illustration + centered content. The site header/footer are supplied by the
 * surrounding SiteLayout route, so this renders page content only (and stays
 * chrome-free inside in-app webviews).
 */
export default function LegalLayout({
  eyebrow,
  title,
  intro,
  art,
  children,
}: LegalLayoutProps) {
  return (
    <>
      <section className="se-hero">
        <div className="se-hero-inner">
          <div className="se-hero-text">
            <span className="se-eyebrow">{eyebrow}</span>
            <h1>{title}</h1>
            <p>{intro}</p>
          </div>
          <div className="se-hero-art">{art}</div>
        </div>
      </section>

      <main className="se-content">{children}</main>
    </>
  );
}
